<template>
  <div class="home-tags">
    <div class="tags-row row-1">
      <a class="tag-item logo-item" href="/brand/" target="_blank" rel="noopener noreferrer">
        <img :src="require('../img/FigmaDDSSlicePNGbd8dbbea8a39f3ee1b22f63d8d790cca.png')" alt="中国品牌" />
      </a>
      <a class="tag-item index-item" href="/brand-index" target="_blank" rel="noopener noreferrer">
        <span>品牌影响力指数</span>
      </a>
      <a class="tag-item qiang-item" href="/specials/brand2022videos/" target="_blank" rel="noopener noreferrer">
        <span>中国品牌<br />强国有我</span>
      </a>
      <a class="tag-item rongmei-item" href="/brand/cluster.html" target="_blank" rel="noopener noreferrer">
        <span>中国品牌<br />融媒集群</span>
      </a>
      <a class="tag-item diaoyan-item" href="/specials/survey/" target="_blank" rel="noopener noreferrer">
        <span>中国品牌<br />发展现状调研行</span>
      </a>
    </div>
    <div class="tags-row row-2">
      <a class="tag-item gongyi-item" href="/coming-soon" target="_blank" rel="noopener noreferrer">
        <span>公益活动</span>
      </a>
      <a class="tag-item zazhishe-item" href="/brand/brand.html" target="_blank" rel="noopener noreferrer">
        <span>《中国品牌》杂志社<br />中国品牌研究院</span>
      </a>
      <a class="tag-item partner-item" href="/specials/partner2026/" target="_blank" rel="noopener noreferrer">
        <img :src="require('../img/FigmaDDSSlicePNGe6f85e727a54500960eda169018bb52a.png')" alt="战略合作伙伴" />
        <span>中国品牌<br />战略合作伙伴</span>
      </a>
      <a class="tag-item fuyao-item" href="/specials/fuyao2026/" target="_blank" rel="noopener noreferrer">
        <span>中国品牌<br />扶摇计划公益项目</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeTags'
}
</script>

<style scoped>
.home-tags {
  width: 1400px;
  height: 346px;
  margin: 0 auto;
  background: url('../img/FigmaDDSSlicePNG63d18e758fa085a1150c8aa6a9e11e01.png') 100% no-repeat;
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  margin-top: 30px;
}
.tags-row {
  width: 1345px;
  display: flex;
  justify-content: center;
  gap: 18px;
  margin: 0 auto;
}
.row-1 {
  height: 133px;
  padding-top: 36px;
  box-sizing: border-box;
}
.row-2 {
  height: 124px;
  margin-top: 47px;
}
.tag-item {
  height: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: transform 0.2s;
  cursor: pointer;
}
.tag-item span {
  font-size: 20px;
  font-family: 'Microsoft YaHei', sans-serif;
  letter-spacing: 1.7142857313156128px;
  text-align: center;
  line-height: 30px;
}
.tag-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.logo-item {
  width: 384px;
  background-color: rgba(191, 75, 74, 1);
}
.logo-item img {
  width: 239px;
  height: 72px;
}
.index-item {
  width: 204px;
  background: url('../img/FigmaDDSSlicePNG23b68fd8718f5b3e17005c6d298b8a05.png') 100% no-repeat;
  background-size: 100% 100%;
}
.index-item span {
  color: rgba(252, 224, 187, 1);
}
.qiang-item {
  width: 155px;
  background-color: rgba(191, 75, 74, 1);
}
.rongmei-item {
  width: 180px;
  background-color: rgba(191, 75, 74, 1);
}
.diaoyan-item {
  width: 348px;
  background-color: rgba(191, 75, 74, 1);
}
.gongyi-item {
  width: 142px;
  background-color: rgba(191, 75, 74, 1);
}
.zazhishe-item {
  width: 218px;
  background-color: rgba(191, 75, 74, 1);
}
.partner-item {
  width: 579px;
  background-color: rgba(191, 75, 74, 1);
  gap: 10px;
}
.partner-item img {
  width: 126px;
  height: 98px;
}
.partner-item span {
  color: rgba(255, 255, 255, 1);
  text-align: left;
}
.fuyao-item {
  width: 348px;
  background-color: rgba(191, 75, 74, 1);
}
.guancha-item {
  width: 180px;
  background-color: rgba(191, 75, 74, 1);
}
.qiang-item span,
.rongmei-item span,
.diaoyan-item span,
.gongyi-item span,
.zazhishe-item span,
.fuyao-item span,
.guancha-item span {
  color: rgba(252, 224, 187, 1);
}
</style>
